/**
 * Ajuda dos campos das esteiras (P-EST-1 e P-EST-2): o quadro, os filtros, a gaveta do
 * cartao, o movimento, o cartao aberto no quadro e o envio ao corretor.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/esteiras': {
    'Lista de esteiras': 'Troca de esteira sem sair do quadro. Os filtros recomecam.',
    Porte:
      'Porte do tomador no cadastro, gravado no cartao ao abrir e a cada movimento. O porte do motor (CRD-002) ainda e regra pendente.',
    Classe:
      'Classe da ultima execucao do motor de credito da cotacao (AA a D), gravada no cartao ao abrir e a cada movimento.',
    'Motivo padronizado':
      'Os motivos que valem nesta esteira, do catalogo de Motivos padronizados. Na coluna que encerra a operacao, o motivo vira o motivo do declinio.',
    Justificativa:
      'Fica no historico do cartao com quem moveu. A coluna que encerra a operacao exige o motivo padronizado ou a justificativa.',
    // P-EST-2: cartao aberto no quadro, revisao de limite, Follow up e envio ao corretor.
    'Tipo do cartao':
      'O tipo do pedido do cartao do tomador na esteira Cadastro: pendencia de cadastro, definicao de grupo economico ou credito SPE/Consorcio.',
    'Titulo do cartao':
      'Opcional, ate 160 caracteres. Sem titulo, o cartao leva o nome do tipo.',
    'Grupo de modalidades':
      'O grupo do limite que o pedido quer rever. Cada grupo aceita um pedido pendente por vez.',
    'Limite pretendido':
      'Valor em reais, com virgula para os centavos. O pedido nao muda o limite: o limite muda em Limites e Taxas do tomador, pela alcada do credito.',
    'Motivo do pedido': 'Opcional. Fica no pedido e no cartao Revisao de Limite.',
    'Novo registro':
      'Registro do Follow up do cartao. Enviar para o corretor grava o registro ja marcado como enviado, com quem enviou e quando.',
    'Mensagem ao corretor':
      'Entra no Follow up da cotacao marcada como enviada e aparece para a corretora no portal. O aviso por e-mail ainda depende de regra da seguradora (EMI-002).',
    'Comentario do envio':
      'Opcional. Vai junto com a lista dos documentos ainda pendentes do objeto do cartao.',
    'Tipo de execucao':
      'O tipo da execucao do motor: credito, cadastro, PEP, subscricao ou resseguro. A execucao anterior ao tipo aparece como credito.',
    'Buscar em todas as esteiras':
      'Procura em todas as esteiras pelo numero da operacao ou da cotacao, objeto, tomador (nome ou CNPJ) ou corretora, a partir de 3 caracteres. Mostra a esteira e a coluna; o clique abre o quadro com o cartao.',
  },
};
